/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignGrants } from '../fn/dc-user/assign-grants';
import { AssignGrants$Params } from '../fn/dc-user/assign-grants';
import { changePassword } from '../fn/dc-user/change-password';
import { ChangePassword$Params } from '../fn/dc-user/change-password';
import { createUser } from '../fn/dc-user/create-user';
import { CreateUser$Params } from '../fn/dc-user/create-user';
import { DcUserDto } from '../models/dc-user-dto';
import { deleteUser } from '../fn/dc-user/delete-user';
import { DeleteUser$Params } from '../fn/dc-user/delete-user';
import { getGrantTargets } from '../fn/dc-user/get-grant-targets';
import { GetGrantTargets$Params } from '../fn/dc-user/get-grant-targets';
import { getUserById } from '../fn/dc-user/get-user-by-id';
import { GetUserById$Params } from '../fn/dc-user/get-user-by-id';
import { getUserCount } from '../fn/dc-user/get-user-count';
import { GetUserCount$Params } from '../fn/dc-user/get-user-count';
import { getUsers } from '../fn/dc-user/get-users';
import { GetUsers$Params } from '../fn/dc-user/get-users';
import { inactivateUser } from '../fn/dc-user/inactivate-user';
import { InactivateUser$Params } from '../fn/dc-user/inactivate-user';
import { modifyUser } from '../fn/dc-user/modify-user';
import { ModifyUser$Params } from '../fn/dc-user/modify-user';
import { PaginatedDataDcUserDto } from '../models/paginated-data-dc-user-dto';
import { reactivateUser } from '../fn/dc-user/reactivate-user';
import { ReactivateUser$Params } from '../fn/dc-user/reactivate-user';
import { revokeGrants } from '../fn/dc-user/revoke-grants';
import { RevokeGrants$Params } from '../fn/dc-user/revoke-grants';
import { RowCount } from '../models/row-count';
import { TargetObjectDto } from '../models/target-object-dto';
import { ValidationError } from '../models/validation-error';

@Injectable({ providedIn: 'root' })
export class DcUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserById()` */
  static readonly GetUserByIdPath = '/api/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserById$Response(params: GetUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<DcUserDto>> {
    return getUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserById(params: GetUserById$Params, context?: HttpContext): Observable<DcUserDto> {
    return this.getUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DcUserDto>): DcUserDto => r.body)
    );
  }

  /** Path part for operation `modifyUser()` */
  static readonly ModifyUserPath = '/api/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyUser$Response(params: ModifyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyUser(params: ModifyUser$Params, context?: HttpContext): Observable<void> {
    return this.modifyUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createUser()` */
  static readonly CreateUserPath = '/api/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params: CreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: CreateUser$Params, context?: HttpContext): Observable<void> {
    return this.createUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteUser()` */
  static readonly DeleteUserPath = '/api/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser$Response(params: DeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUser(params: DeleteUser$Params, context?: HttpContext): Observable<void> {
    return this.deleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reactivateUser()` */
  static readonly ReactivateUserPath = '/api/users/{id}/reactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateUser$Response(params: ReactivateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reactivateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateUser(params: ReactivateUser$Params, context?: HttpContext): Observable<void> {
    return this.reactivateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `inactivateUser()` */
  static readonly InactivateUserPath = '/api/users/{id}/inactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inactivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateUser$Response(params: InactivateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return inactivateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inactivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inactivateUser(params: InactivateUser$Params, context?: HttpContext): Observable<void> {
    return this.inactivateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `revokeGrants()` */
  static readonly RevokeGrantsPath = '/api/users/{id}/revoke-grants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeGrants()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeGrants$Response(params: RevokeGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return revokeGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `revokeGrants$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  revokeGrants(params: RevokeGrants$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.revokeGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `changePassword()` */
  static readonly ChangePasswordPath = '/api/users/{id}/change-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePassword$Response(params: ChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return changePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changePassword(params: ChangePassword$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.changePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `assignGrants()` */
  static readonly AssignGrantsPath = '/api/users/{id}/assign-grants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignGrants()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignGrants$Response(params: AssignGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
    return assignGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignGrants$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignGrants(params: AssignGrants$Params, context?: HttpContext): Observable<Array<ValidationError>> {
    return this.assignGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ValidationError>>): Array<ValidationError> => r.body)
    );
  }

  /** Path part for operation `getUsers()` */
  static readonly GetUsersPath = '/api/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers$Response(params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataDcUserDto>> {
    return getUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUsers(params?: GetUsers$Params, context?: HttpContext): Observable<PaginatedDataDcUserDto> {
    return this.getUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedDataDcUserDto>): PaginatedDataDcUserDto => r.body)
    );
  }

  /** Path part for operation `getGrantTargets()` */
  static readonly GetGrantTargetsPath = '/api/users/grant-targets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGrantTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrantTargets$Response(params?: GetGrantTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<TargetObjectDto>;
}>> {
    return getGrantTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGrantTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGrantTargets(params?: GetGrantTargets$Params, context?: HttpContext): Observable<{
[key: string]: Array<TargetObjectDto>;
}> {
    return this.getGrantTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<TargetObjectDto>;
}>): {
[key: string]: Array<TargetObjectDto>;
} => r.body)
    );
  }

  /** Path part for operation `getUserCount()` */
  static readonly GetUserCountPath = '/api/users/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserCount$Response(params?: GetUserCount$Params, context?: HttpContext): Observable<StrictHttpResponse<RowCount>> {
    return getUserCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserCount(params?: GetUserCount$Params, context?: HttpContext): Observable<RowCount> {
    return this.getUserCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<RowCount>): RowCount => r.body)
    );
  }

}
